import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home-page" }

import { ref, onMounted } from 'vue';
import moment from 'moment';
import { storage } from '@/utils/storage'
import GameSection from './components/GameSection.vue';
import NoticeBar from './components/NoticeBar.vue';
import FinanceBar from './components/FinanceBar.vue';
import PageFooter from './components/PageFooter.vue';
import DownloadBanner from '@/components/DownloadBanner.vue';
import ReturnGiftBtn from '@/components/ReturnGiftBtn.vue';
// import SuspendIcon from '@/components/SuspendIcon.vue';
import { storeToRefs } from 'pinia';
import { useUserStore, usePopupStore, useSettingsStore } from '@/store'


export default {
  __name: 'index',
  setup(__props) {

const userStore = useUserStore();
const { uid } = storeToRefs(userStore);
const popupStore = usePopupStore();
const settingsStore = useSettingsStore()
const { showDownloadBanner, showTopTip } = storeToRefs(settingsStore);

const gameMenuFixed = ref(false);
const showAnnouncement = ref(false);

onMounted(() => {
  let today = moment().format('YYYY-MM-DD');
  let lastNoticeDate = storage.get('lastNoticeDate');
  if (!lastNoticeDate || lastNoticeDate != today) {
    popupStore.set('showAgeVerifiction', true)
    storage.set('lastNoticeDate', today)
  }
  if(userStore.uid) {
    let lastAnnouncementDate = storage.get('lastAnnouncementDate');
    if (!lastAnnouncementDate || lastAnnouncementDate != today) {
      showAnnouncement.value = true;
      storage.set('lastAnnouncementDate', today)
    }
  }
});

return (_ctx, _cache) => {
  const _component_TopTip = _resolveComponent("TopTip")
  const _component_HeaderBar = _resolveComponent("HeaderBar")
  const _component_Announcement = _resolveComponent("Announcement")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TopTip),
    _createVNode(DownloadBanner),
    _createVNode(_component_HeaderBar),
    _createVNode(NoticeBar),
    _createElementVNode("div", {
      class: _normalizeClass(["home-page-scroll", { 'with-download-banner': _unref(showDownloadBanner), 'with-action-bar': !!_unref(uid), 'with-top-tip': _unref(showTopTip) }])
    }, [
      (_unref(uid))
        ? (_openBlock(), _createBlock(FinanceBar, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(GameSection, { menuFixed: gameMenuFixed.value }, null, 8, ["menuFixed"]),
      _createVNode(PageFooter)
    ], 2),
    (showAnnouncement.value)
      ? (_openBlock(), _createBlock(_component_Announcement, {
          key: 0,
          onOnClose: _cache[0] || (_cache[0] = $event => (showAnnouncement.value = false))
        }))
      : _createCommentVNode("", true),
    (_unref(uid))
      ? (_openBlock(), _createBlock(ReturnGiftBtn, { key: 1 }))
      : _createCommentVNode("", true)
  ]))
}
}

}